import { useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Mail, X } from "lucide-react";
import { toast } from "sonner";

export default function VerifyBanner() {
  const { user } = useAuth();
  const [dismissed, setDismissed] = useState(false);
  const [sending, setSending] = useState(false);

  // Only show for signed-in users whose email isn't verified yet
  if (!user || user === false || user.email_verified !== false || dismissed) return null;

  const resend = async () => {
    setSending(true);
    try {
      await api.post("/auth/resend-verification");
      toast.success("Verification email sent — check your inbox.");
    } catch (e) {
      const detail = e.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Could not send. Try again in a moment.");
    }
    setSending(false);
  };

  return (
    <div data-testid="verify-banner" className="bg-[var(--terracotta)]/10 border-b border-[var(--terracotta)]/30">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-2.5 flex items-center justify-between gap-4 text-sm">
        <div className="flex items-center gap-2.5 min-w-0">
          <Mail className="w-4 h-4 text-[var(--forest)] shrink-0" strokeWidth={1.8} />
          <span className="text-[var(--ink)] truncate">
            Please confirm your email
            <span className="text-[var(--ink-soft)] hidden sm:inline"> — check your inbox for the welcome link.</span>
          </span>
        </div>
        <div className="flex items-center gap-3 shrink-0">
          <button data-testid="verify-resend-btn" onClick={resend} disabled={sending}
            className="text-xs font-medium text-[var(--forest)] hover:underline disabled:opacity-50">
            {sending ? "Sending…" : "Resend"}
          </button>
          <button data-testid="verify-dismiss-btn" onClick={() => setDismissed(true)}
            aria-label="Dismiss banner"
            className="text-[var(--ink-soft)] hover:text-[var(--ink)]">
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
